<script>
  import { onMount } from "svelte";
  import Header from "../components/Header.svelte";
  import Footer from "../components/Footer.svelte";
  import { navigate } from "svelte-routing";
  import { Icon } from "svelte-awesome";
  import { 
    faExclamationTriangle,
    faDog,
    faCat,
    faHandshake
   } from "@fortawesome/free-solid-svg-icons";
  import { surveyFilters, isAdmin } from "../stores/stores";

  const showAdoptables = () => {
    surveyFilters.set("");
    navigate("/adoptables");
  };

  const startSurvey = () => {
    navigate("/survey");
  };

  const totalAdoptions = 2100;
  const totalAdoptedDogs = parseInt(totalAdoptions * 0.8);
  const totalAdoptedCats = parseInt(totalAdoptions * 0.2);
  
  let countAdoptions = 0;
  let countAdoptedDogs = 0;
  let countAdoptedCats = 0;

  const smoothCount = () => {
    let pending = false;
    if (countAdoptions < totalAdoptions) {
      countAdoptions += 10;
      pending = true;
    }
    if (countAdoptedDogs < totalAdoptedDogs) {
      countAdoptedDogs += 8;
      pending = true;
    }
    if (countAdoptedCats < totalAdoptedCats) {
      countAdoptedCats += 2;
      pending = true;
    }
    if (pending) setTimeout(smoothCount, 25);
  };

  onMount(() => {
    if ($isAdmin) {
      navigate("/_admin");
    } else {
      smoothCount();
    }
  });
</script>

<Header />
<div id="main-content" class="welcome">
  <!-- Title  -->
  <div class="row title">
    <div class="col-fill col">
      <h1>Vida digna y un hogar, eso queremos lograr</h1>
    </div>
  </div>

  <!-- Counters -->
  <div class="row counters">
    <div class="col-fill col counter-fill"></div>
    <div class="sm-2 col counter">
      <Icon scale="3" data={faHandshake} />
      <br />
      <h3>{countAdoptions}</h3>
      <p>Casos de éxito</p>
    </div>
    <div class="sm-2 col counter">
      <Icon scale="3" data={faDog} />
      <br />
      <h3>{countAdoptedDogs}</h3>
      <p>Perros adoptados</p>
    </div>
    <div class="sm-2 col counter">
      <Icon scale="3" data={faCat} />
      <br />
      <h3>{countAdoptedCats}</h3>
      <p>Gatos adoptados</p>
    </div>
    <div class="col-fill col counter-fill"></div>
  </div>

  <!-- Content -->
  <div class="row content">
    <div class="sm-6 col content-left">
      <h2>Adoptar es ayudar</h2>
      <h3>Mira a todos nuestros adoptables que están en espera de un hogar</h3>
      <p>
        <Icon data={faExclamationTriangle} />
        Advertencia: Puedes enamorarte de muchos
      </p>
      <button on:click={showAdoptables}> Explorar </button>
    </div>
    <div class="sm-6 col content-right">
      <img src="images/bg_dog.jpg" class="no-border" alt="Cat in the street">
    </div>
  </div>
  <div class="row content-alt">
    <div class="sm-6 col content-left">
      <img src="images/bg_cat.jpg" class="no-border" alt="Dog in the street">
    </div>
    <div class="sm-6 col content-right">
      <h2>¿Te interesa adoptar, pero no sabes cuál elegir?</h2>
      <h3>Te ayudamos a encontrar a tu mascota ideal</h3>
      <br />
      <button on:click={startSurvey}> ¡Comienza Aquí! </button>
    </div>
  </div>
</div>
<Footer />

<style>
  .content-left, .content-right {
    margin: 0;
    padding: 0;
  }

  .row.content button {
    color: #ffffff;
    background-color: #e98c40;
    border-color: #e98c40;
  }

  .row.content-alt button {
    color: #e98c40;
    background-color: #ffffff;
    border-color: #ffffff;
  }

  .row.title {
    color: #ffffff;
    background-color: #5a351f;
    margin-bottom: 0;
  }

  .welcome {
    text-align: center;
    display: block;
    margin: auto;
  }

  .row.content, .row.content-alt {
    margin: 0;
  }

  .row.content-alt img, .row.content img {
    margin: 0;
    padding: 0;
    height: 50vh;
    width: 100vw;
    object-fit: cover;
  }

  .row.content-alt {
    background-color: #e98c40;
    color: #ffffff;
  }

  .row.counters {
    margin: 0;
  }

  /*
  Mobile devices
  */
  @media screen and (max-width: 767px) {
    .row.counters > .counter {
      background-color: #e5343e;
      color: #ffffff;
      margin: 1vh 0;
    }

    .row.counters > .counter-fill {
      background-color: #ffffff;
      margin: 0;
    }

  }

  /*
  Desktop, laptop
  */
  @media screen and (min-width: 768px) {
    .row.counters > .counter {
      background-color: #e5343e;
      color: #ffffff;
      margin: 0;
    }

    .row.counters > .counter-fill {
      background-color: #e5343e;
      margin: 0;
    }
  }
</style>
